const REF_STORAGE_KEY = 'ewio_ref';

/**
 * Persist ?ref= or ?utm_campaign= (alphanumeric, 2–64 chars) for challenge share attribution.
 * Canonical URLs stay query-free; shared links may append {@link referralQuerySuffix}.
 */
export function captureReferralFromUrl() {
  if (typeof window === 'undefined') return;
  try {
    const params = new URLSearchParams(window.location.search);
    const raw = params.get('ref') || params.get('utm_campaign');
    if (!raw) return;
    const cleaned = String(raw).trim();
    if (!/^[a-zA-Z0-9_-]{2,64}$/.test(cleaned)) return;
    window.localStorage.setItem(REF_STORAGE_KEY, cleaned);
  } catch {
    /* ignore quota / private mode */
  }
}

export function getStoredReferral() {
  if (typeof window === 'undefined') return '';
  try {
    return window.localStorage.getItem(REF_STORAGE_KEY) || '';
  } catch {
    return '';
  }
}

/** Returns `?ref=tag` or empty string. */
export function referralQuerySuffix() {
  const r = getStoredReferral();
  return r ? `?ref=${encodeURIComponent(r)}` : '';
}
